import React, {useState} from 'react';
import {useMutation} from '@apollo/react-hooks';
import {DEMO_REQUEST_SUBMIT} from '../../graphql/mutations';
import Message from '../messages';
import Button from '../button';
import Select from '../select';
import {isValidEmail} from '../../helpers/constants';
import {checkedCircleIcon} from '../../images/svgIcons';
import '../../styles/auth.scss';
import './styles.scss';

const industryOptions = [
  {label: 'eCommerce', value: 'eCommerce'},
  {label: 'Education', value: 'Education'},
  {label: 'Entertainment', value: 'Entertainment'},
  {label: 'Financial Services', value: 'Financial Services'},
  {label: 'Gambling', value: 'Gambling'},
  {label: 'Gaming', value: 'Gaming'},
  {label: 'Government', value: 'Government'},
  {label: 'Healthcare', value: 'Healthcare'},
  {label: 'Information Technology', value: 'Information Technology'},
  {label: 'Legal Services', value: 'Legal Services'},
  {label: 'Marketing & Advertising', value: 'Marketing & Advertising'},
  {label: 'News & Media', value: 'News & Media'},
  {label: 'Nonprofit', value: 'Nonprofit'},
  {label: 'Online Services', value: 'Online Services'},
  {label: 'Professional Services', value: 'Professional Services'},
  {label: 'Real Estate', value: 'Real Estate'},
  {label: 'Retail', value: 'Retail'},
  {label: 'Travel & Tourism', value: 'Travel & Tourism'},
  {label: 'Utilities', value: 'Utilities'},
  {label: 'Other', value: 'Other'},
];

const RequestDemo = () => {
  const [name, setName] = useState('');
  const [businessEmail, setBusinessEmail] = useState('');
  const [industry, setIndustry] = useState({label: 'Select', value: ''});
  const [role, setRole] = useState('');
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const [sendRequestDemo, {loading}] = useMutation(DEMO_REQUEST_SUBMIT);

  const handleSubmit = async () => {
    setErrorMessage('');
    setError(false);
    if (!name.trim() || !businessEmail.trim() || !industry || !role.trim() || !message.trim()) {
      setErrorMessage('Please fill out all the required fields');
      setError(true);
      return;
    } else if (!isValidEmail(businessEmail.trim())) {
      setErrorMessage('Please enter valid email address');
      setError(true);
      return;
    }
    const {data} = await sendRequestDemo({
      variables: {
        settings: {
          name: name,
          businessEmail: businessEmail,
          industry: industry.value,
          role: role,
          message: message,
          productType: 'hexomatic',
        },
      },
    });
    if (data && data.DemoRequestOps && data.DemoRequestOps.sendEmail && data.DemoRequestOps.sendEmail.error) {
      setErrorMessage('Something went wrong.');
      setError(true);
    } else {
      setSuccess(true);
    }
  };

  const handleChangeName = (e: any) => {
    setName(e.target.value);
    setErrorMessage('');
  };
  const handleChangeEmail = (e: any) => {
    setBusinessEmail(e.target.value);
    setErrorMessage('');
  };
  const handleChangeRole = (e: any) => {
    setRole(e.target.value);
    setErrorMessage('');
  };
  const handleChangeMessage = (e: any) => {
    setMessage(e.target.value);
    setErrorMessage('');
  };
  return (
    <div className="demo-block">
      {!success ? (
        <>
          <h4 className="title">Request a Demo</h4>
          <div className="forms">
            <div className="wrapper">
              <div className="form-item">
                <label htmlFor="name">
                  Name <span>*</span>
                </label>
                <input
                  required
                  placeholder="John Smith"
                  type="text"
                  name="name"
                  id="name"
                  onChange={handleChangeName}
                  value={name}
                  maxLength={255}
                  className={error && !name.trim() ? 'danger' : ''}
                />
              </div>
              <div className="form-item">
                <label htmlFor="workEmail">
                  Business email <span>*</span>
                </label>
                <input
                  className={
                    errorMessage === 'Please enter valid email address' || (error && !businessEmail.trim())
                      ? 'danger'
                      : ''
                  }
                  required
                  placeholder="example@company.com"
                  type="email"
                  name="workEmail"
                  id="workEmail"
                  onChange={handleChangeEmail}
                  value={businessEmail}
                  maxLength={320}
                />
              </div>
            </div>

            <div className="d-flex wrapper-fields justify-content-between align-items-center">
              <div className="form-item width_48">
                <label>
                  Industry <span>*</span>
                </label>
                <Select
                  className={`${error && !industry.value ? 'brd-err' : ''} `}
                  options={industryOptions}
                  value={industry}
                  onChange={setIndustry}
                />
              </div>

              <div className="form-item width_48">
                <label htmlFor="jobTitle">
                  Role <span>*</span>
                </label>
                <input
                  className={error && !role.trim() ? 'danger' : ''}
                  required
                  placeholder="Sales Manager"
                  type="text"
                  name="role"
                  id="role"
                  onChange={handleChangeRole}
                  value={role}
                  maxLength={255}
                />
              </div>
            </div>

            <div className="d-flex align-items-start flex-column w-100">
              <label className="textarea-label" htmlFor="message">
                Message <span>*</span>
              </label>
              <textarea
                value={message}
                maxLength={2000}
                onChange={handleChangeMessage}
                name="message"
                id="message"
                placeholder="Tell us a bit about what your needs are, so we can make sure your demo is to the point."
                cols={30}
                rows={10}
                required
                className={error && !message.trim() ? 'danger' : ''}
              />
            </div>

            {errorMessage && (
              <div className="mt-2">
                <Message type="error" text={errorMessage || 'Please fill out all the required fields'} />
              </div>
            )}
          </div>

          <div className="submit-block">
            <Button loading={loading} disabled={loading} primary className="my-2" onClick={handleSubmit}>
              Submit
            </Button>
          </div>
        </>
      ) : (
        <div className="d-flex mt-5 flex-column align-items-center justify-content-center mb-5">
          <div className="check-icon">{checkedCircleIcon}</div>
          <div className="mt-3">
            <strong>Demo request has been successfully sent.</strong>
          </div>
        </div>
      )}
    </div>
  );
};

export default RequestDemo;
